// import React from 'react';
// import { FileText, CheckSquare, Home, Wallet, MessageCircle } from 'lucide-react';

// interface FooterNavLayout5Props {
//   colors: {
//     background: string;
//     text: string;
//     activeBackground: string;
//     activeText: string;
//     icon: string;
//   };
// }

// const FooterNavLayout5: React.FC<FooterNavLayout5Props> = ({ colors }) => {
//   const navItems = [
//     { icon: FileText, label: 'History' },
//     { icon: CheckSquare, label: 'All Bids' },
//     { icon: Home, label: 'Home', active: true },
//     { icon: Wallet, label: 'Wallet' },
//     { icon: MessageCircle, label: 'Chat' }
//   ];

//   return (
//     <div 
//       className="flex items-center justify-around py-3 px-4 rounded-t-2xl"
//       style={{ backgroundColor: colors.background }}
//     >
//       {navItems.map((item, index) => (
//         <div key={index} className="flex flex-col items-center">
//           {item.active ? (
//             <div className="flex flex-col items-center">
//               <div 
//                 className="w-12 h-12 rounded-full flex items-center justify-center mb-1 shadow-lg"
//                 style={{ backgroundColor: colors.activeBackground }}
//               >
//                 <item.icon 
//                   className="w-5 h-5" 
//                   style={{ color: colors.activeText }}
//                 />
//               </div>
//               <span 
//                 className="text-xs font-medium"
//                 style={{ color: colors.text }}
//               >
//                 {item.label}
//               </span>
//             </div>
//           ) : (
//             <div className="flex flex-col items-center">
//               <item.icon 
//                 className="w-5 h-5 mb-1" 
//                 style={{ color: colors.icon }}
//               />
//               <span 
//                 className="text-xs font-medium"
//                 style={{ color: colors.text }}
//               >
//                 {item.label}
//               </span>
//             </div>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default FooterNavLayout5;







// import React, { useState } from 'react';
// import { FileText, CheckSquare, Home, Wallet, MessageCircle } from 'lucide-react';

// interface FooterNavLayout5Props {
//   colors: {
//     background: string;
//     text: string;
//     activeBackground: string;
//     activeText: string;
//     icon: string;
//   };
// }

// const FooterNavLayout5: React.FC<FooterNavLayout5Props> = ({ colors }) => {
//   const navItems = [
//     { icon: FileText, label: 'History' },
//     { icon: CheckSquare, label: 'All Bids' },
//     { icon: Home, label: 'Home' },
//     { icon: Wallet, label: 'Wallet' },
//     { icon: MessageCircle, label: 'Chat' }
//   ];

//   const [activeIndex, setActiveIndex] = useState<number>(2);

//   return (
//     <div className="relative">
//       <div 
//         className="flex items-end justify-around py-4 px-4 rounded-3xl shadow-lg"
//         style={{ backgroundColor: colors.background }}
//       >
//         {navItems.map((item, index) => {
//           const isActive = index === activeIndex;
          
//           if (isActive) {
//             return (
//               <button
//                 key={index}
//                 onClick={() => setActiveIndex(index)}
//                 className="flex flex-col items-center -mt-8"
//               >
//                 <div 
//                   className="w-24 h-24 rounded-full flex flex-col items-center justify-center shadow-[0_8px_24px_rgba(0,0,0,0.3)] mb-2"
//                   style={{ backgroundColor: colors.activeBackground }}
//                 >
//                   <item.icon 
//                     className="w-8 h-8 mb-1" 
//                     style={{ color: colors.activeText }}
//                   />
//                   <span 
//                     className="text-sm font-medium"
//                     style={{ color: colors.activeText }}
//                   >
//                     {item.label}
//                   </span>
//                 </div>
//               </button>
//             );
//           }
          
//           return (
//             <button
//               key={index}
//               onClick={() => setActiveIndex(index)}
//               className="flex flex-col items-center"
//             >
//               <item.icon 
//                 className="w-7 h-7 mb-1" 
//                 style={{ color: colors.icon }}
//               />
//               <span 
//                 className="text-sm font-medium"
//                 style={{ color: colors.text }}
//               >
//                 {item.label}
//               </span>
//             </button>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default FooterNavLayout5;







import React, { useState } from 'react';
import { FileText, CheckSquare, Home, Wallet, MessageCircle } from 'lucide-react';

interface FooterNavLayout5Props {
  colors: {
    background: string;
    text: string;
    activeBackground: string;
    activeText: string;
    icon: string;
  };
}

const FooterNavLayout5: React.FC<FooterNavLayout5Props> = ({ colors }) => {
  const navItems = [
    { icon: FileText, label: 'History' },
    { icon: CheckSquare, label: 'All Bids' },
    { icon: Home, label: 'Home' },
    { icon: Wallet, label: 'Wallet' },
    { icon: MessageCircle, label: 'Chat' }
  ];

  const [activeIndex, setActiveIndex] = useState<number>(2);

  return (
    <div className="relative w-full">
      {/* Main Navigation Bar */}
      <div 
        className="flex items-center justify-around py-3 px-4 rounded-2xl shadow-md relative"
        style={{ backgroundColor: colors.background }}
      >
        {navItems.map((item, index) => {
          const isActive = index === activeIndex;
          
          return (
            <button
              key={index}
              onClick={() => setActiveIndex(index)}
              className={`flex flex-col items-center relative flex-1 ${
                isActive ? 'mx-1' : ''
              }`}
            >
              {isActive ? (
                // Active state: Circle with icon and label inside, with grey ring
                <>
                  {/* Circle that protrudes upward with thin grey ring around it */}
                  <div 
                    className="w-16 h-16 rounded-full flex flex-col items-center justify-center shadow-lg -mt-8 relative"
                    style={{ 
                      backgroundColor: colors.activeBackground,
                      border: '3px solid #e5e7eb' // Thin light grey ring
                    }}
                  >
                    <item.icon 
                      className="w-6 h-6 mb-0.5" 
                      style={{ color: colors.activeText }}
                    />
                    {/* Text inside the circle in white */}
                    <span 
                      className="text-[10px] font-medium leading-tight"
                      style={{ color: colors.activeText }}
                    >
                      {item.label}
                    </span>
                  </div>
                </>
              ) : (
                // Inactive state: Icon above, text below (both in blue)
                <>
                  <item.icon 
                    className="w-6 h-6 mb-1" 
                    style={{ color: colors.icon }}
                  />
                  <span 
                    className="text-xs font-medium"
                    style={{ color: colors.text }}
                  >
                    {item.label}
                  </span>
                </>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default FooterNavLayout5;


